import React from 'react';
import "./position.css";

export default function HeaderCell(cellHeader) {
    if (cellHeader.column.dataField == 'priceDelta')
        return (        
            <div className="positionColumnHeader">Изменение<br />цены</div>
        );

    if (cellHeader.column.dataField == 'balancePrice')
        return (
            <div className="positionColumnHeader">Цена<br />покупки</div>
        );

    if (cellHeader.column.dataField == 'price')
        return (
            <div className="positionColumnHeader">Текущая<br />цена</div>
        );

    return (
        <div className="positionColumnHeader">{cellHeader.column.caption}</div>      
    );
}


// WEBPACK FOOTER //
// ./App/containers/position/HeaderCell.jsx